import { gcmState } from '@/features/game-window-integration/helpers/GCM/state';
import { WrapperProxy } from '@/features/wrapper-proxy/wrapper-proxy';

export const toggleMute = (val: boolean): void => {
  if (!gcmState.initComplete || !gcmState.gcm) return;

  WrapperProxy.setAudio(val);
  gcmState.gcm.optionHasChanged('MUTE', !val);
};

export const togglePaytable = (): void => {
  if (!gcmState.initComplete || !gcmState.gcm) return;

  gcmState.options.PAYTABLE = !gcmState.options.PAYTABLE;
  gcmState.gcm.optionHasChanged('PAYTABLE', gcmState.options.PAYTABLE);
};

export const toggleHowToPlay = (): void => {
  if (!gcmState.initComplete || !gcmState.gcm) return;

  gcmState.options.HELP = !gcmState.options.HELP;
  gcmState.gcm.optionHasChanged('HELP', gcmState.options.HELP);
};

export const sendStopAutoplay = (): void => {
  if (!gcmState.initComplete || !gcmState.gcm) return;

  gcmState.gcm.stopAutoplay();
};

export const updateBalance = (balance: number): void => {
  if (!gcmState.initComplete || !gcmState.gcm || !balance) return;

  try {
    const balances = { CASH: { amount: balance }, BONUS: { amount: 0 } };
    gcmState.gcm.balancesUpdate(balances);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Game not loaded...');
  }
};
